/* tooth-page.js — rebuilt from Dev Package script.js (hero→specs only) */
(function () {
  if (window.__toothPageInitialized) return;
  window.__toothPageInitialized = true;

  function initToothPage() {
    const isThemeEditor = Boolean(window.Shopify?.designMode);

    document.querySelectorAll('.section-tooth-hero').forEach(heroSection => {
      const dialog = heroSection.querySelector('.film-dialog');
      const filmVideos = dialog?.querySelectorAll('video');
      const stopFilm = () => filmVideos?.forEach(video => {
        video.pause();
        video.currentTime = 0;
      });

      heroSection.querySelectorAll('.watch-button').forEach(button => {
        if (button.dataset.toothBound) return;
        button.dataset.toothBound = '1';
        button.addEventListener('click', () => {
          dialog?.showModal();
          const activeFilm = window.matchMedia('(max-width: 700px)').matches
            ? dialog?.querySelector('.film-mobile')
            : dialog?.querySelector('.film-desktop');
          activeFilm?.play().catch(() => {});
        });
      });

      dialog?.querySelectorAll('.close-film').forEach(button => {
        if (button.dataset.toothBound) return;
        button.dataset.toothBound = '1';
        button.addEventListener('click', () => {
          stopFilm();
          dialog.close();
        });
      });

      if (dialog && !dialog.dataset.toothBound) {
        dialog.dataset.toothBound = '1';
        dialog.addEventListener('click', event => {
          if (event.target === dialog) {
            stopFilm();
            dialog.close();
          }
        });
      }
    });

    document.querySelectorAll('.correction-heading').forEach(correctionHeading => {
      if (correctionHeading.dataset.toothBound) return;
      correctionHeading.dataset.toothBound = '1';
      const highlightSteps = () => {
        correctionHeading.classList.remove('is-active');
        void correctionHeading.offsetWidth;
        correctionHeading.classList.add('is-active');
      };
      correctionHeading.addEventListener('click', highlightSteps);
      correctionHeading.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          highlightSteps();
        }
      });
    });

    document.querySelectorAll('.ingredients-visual').forEach(visual => {
      const callouts = visual.querySelectorAll('.ingredient-callout');
      callouts.forEach(badge => {
        if (badge.dataset.toothBound) return;
        badge.dataset.toothBound = '1';
        badge.addEventListener('click', () => {
          callouts.forEach(item => {
            item.classList.remove('active');
            item.setAttribute('aria-selected', 'false');
          });
          badge.classList.add('active');
          badge.setAttribute('aria-selected', 'true');
        });
      });
    });

    document.querySelectorAll('.grape-freshness-section').forEach(freshnessSection => {
      const freshnessPoints = freshnessSection.querySelectorAll('.freshness-point');
      const freshnessImage = freshnessSection.querySelector('.grape-freshness-visual img');
      freshnessPoints.forEach(point => {
        if (point.dataset.toothBound) return;
        point.dataset.toothBound = '1';
        point.addEventListener('click', () => {
          freshnessPoints.forEach(item => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          point.classList.add('is-active');
          point.setAttribute('aria-pressed', 'true');
          freshnessSection.setAttribute('data-freshness-active', point.dataset.freshness || 'grape');
          if (freshnessImage && point.dataset.image) {
            freshnessImage.src = point.dataset.image;
            freshnessImage.alt = point.dataset.imageAlt || '';
          }
        });
      });
    });

    const revealItems = document.querySelectorAll('.toothpaste-page .reveal');
    if (isThemeEditor) {
      revealItems.forEach(item => item.classList.add('visible'));
    }

    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    }), { threshold: 0.14 });
    revealItems.forEach(item => {
      if (!item.classList.contains('visible')) observer.observe(item);
    });

    const headlineObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('title-visible');
        headlineObserver.unobserve(entry.target);
      }
    }), { threshold: 0.28 });
    document.querySelectorAll('.toothpaste-page h1, .toothpaste-page h2').forEach(title => {
      if (!title.classList.contains('title-enter')) {
        title.classList.add('title-enter');
      }
      if (isThemeEditor) title.classList.add('title-visible');
      else if (!title.classList.contains('title-visible')) headlineObserver.observe(title);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToothPage);
  } else {
    initToothPage();
  }
  document.addEventListener('shopify:section:load', initToothPage);
})();
